<div class="add-venue-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="add-venue-modal" role="dialog" aria-modal="true" aria-labelledby="addVenueTitle">
    <div class="add-venue-header">
      <tm1-typography id="addVenueTitle" type="title-section">
        {{ step === 'form' ? 'Add venue' : 'Confirm new venue' }}
      </tm1-typography>
      <button type="button" class="add-venue-close" aria-label="Close" (click)="cancel()">×</button>
    </div>

  <tm1-banner *ngIf="saveError" appearance="error" class="add-venue-banner">{{ saveError }}</tm1-banner>

  <ng-container *ngIf="step === 'form'">
    <div class="add-venue-form">
      <div class="field-group">
        <tm1-typography type="body-s">Type</tm1-typography>
        <div class="type-toggle">
          <label>
            <input type="radio" name="venueType" value="standard"
                   [checked]="type === 'standard'"
                   (change)="onTypeChange('standard')" />
            Standard
          </label>
          <label>
            <input type="radio" name="venueType" value="parent"
                   [checked]="type === 'parent'"
                   (change)="onTypeChange('parent')" />
            Parent
          </label>
        </div>
      </div>

      <tm1-text-field
        ngDefaultControl
        appearance="outline"
        inputsize="regular"
        label="Venue ID"
        placeholder="e.g. KovZpaooxe or LVGP-parent"
        type="text"
        [(ngModel)]="id"
        name="venueId">
      </tm1-text-field>

      <tm1-text-field
        ngDefaultControl
        appearance="outline"
        inputsize="regular"
        [label]="type === 'parent' ? 'Name (must contain -parent)' : 'Name'"
        placeholder="Display name"
        type="text"
        [(ngModel)]="name"
        name="venueName">
      </tm1-text-field>

      <div class="field-group">
        <label for="venueTimezone" class="field-label">Timezone</label>
        <input id="venueTimezone"
               class="timezone-input"
               type="text"
               list="iana-timezones"
               placeholder="Start typing to search…"
               [(ngModel)]="timezone"
               name="venueTimezone" />
        <datalist id="iana-timezones">
          <option *ngFor="let tz of timezones" [value]="tz"></option>
        </datalist>
      </div>

      <div class="field-group">
        <label for="venueContinent" class="field-label">Continent</label>
        <input id="venueContinent"
               class="timezone-input"
               type="text"
               list="venue-continents"
               placeholder="e.g. Australia"
               [(ngModel)]="continent"
               name="venueContinent" />
        <datalist id="venue-continents">
          <option *ngFor="let c of continents" [value]="c"></option>
        </datalist>
      </div>

      <tm1-text-field
        ngDefaultControl
        appearance="outline"
        inputsize="regular"
        label="City"
        placeholder="e.g. Sydney"
        type="text"
        [(ngModel)]="city"
        name="venueCity">
      </tm1-text-field>

      <div class="field-group">
        <tm1-typography type="body-s">Context</tm1-typography>
        <div class="context-options" *ngIf="type === 'standard'; else parentContext">
          <label *ngFor="let ctx of allContexts">
            <input type="checkbox"
                   [checked]="context[ctx]"
                   (change)="onContextToggle(ctx, $any($event.target).checked)" />
            {{ ctx }}
          </label>
        </div>
        <ng-template #parentContext>
          <tm1-typography type="body-s" class="context-locked">
            Parent venues are locked to <b>report</b> only.
          </tm1-typography>
        </ng-template>
      </div>

      <div class="field-group" *ngIf="type === 'standard'">
        <tm1-typography type="body-s">Parents</tm1-typography>
        <div class="parent-options" *ngIf="parentOptions.length; else noParentOptions">
          <label *ngFor="let p of parentOptions">
            <input type="checkbox"
                   [checked]="parents.includes(p.id)"
                   (change)="onParentToggle(p.id, $any($event.target).checked)" />
            {{ p.name }} <span class="muted">({{ p.id }})</span>
          </label>
        </div>
        <ng-template #noParentOptions>
          <tm1-typography type="body-s" class="muted">No parent venues exist yet.</tm1-typography>
        </ng-template>
      </div>

      <tm1-banner *ngIf="validationError" appearance="warning" class="add-venue-banner">
        {{ validationError }}
      </tm1-banner>

      <div class="add-venue-actions">
        <tm1-button variant="outline" (click)="cancel()">Cancel</tm1-button>
        <tm1-button variant="solid" (click)="proceedToConfirm()">Review</tm1-button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'confirm'">
    <div class="add-venue-confirm">
      <tm1-typography type="body-m">
        You are about to add the following venue. This will overwrite the <b>venueListExtended</b>
        record (the previous version is backed up for 30 days).
      </tm1-typography>

      <dl class="confirm-list">
        <dt>Type</dt><dd>{{ type === 'parent' ? 'Parent' : 'Standard' }}</dd>
        <dt>Venue ID</dt><dd>{{ id }}</dd>
        <dt>Name</dt><dd>{{ name }}</dd>
        <dt>Timezone</dt><dd>{{ timezone || '—' }}</dd>
        <dt>Continent</dt><dd>{{ continent || '—' }}</dd>
        <dt>City</dt><dd>{{ city || '—' }}</dd>
        <dt>Context</dt>
        <dd>
          <span class="context-badges">
            <tm1-badge *ngFor="let c of selectedContexts" appearance="accent" baseColor="success" circular="">
              {{ c }}
            </tm1-badge>
          </span>
        </dd>
        <dt>Parents</dt>
        <dd>
          <span class="context-badges" *ngIf="parents.length; else noParents">
            <tm1-badge *ngFor="let p of parents" appearance="accent" baseColor="info" circular="">{{ p }}</tm1-badge>
          </span>
          <ng-template #noParents>—</ng-template>
        </dd>
      </dl>

      <div class="connector-update">
        <tm1-typography type="body-s" class="connector-heading">
          <b>One more step — Kafka connector config</b>
        </tm1-typography>
        <tm1-typography type="body-s">
          After saving, open the connector YAML and <b>append the snippet below</b> to the
          <code>forms.venueFilter1.filter.condition</code> allowlist on line 24 (before the closing
          <code>)]"</code>).
        </tm1-typography>
        <a [href]="connectorYamlUrl" target="_blank" rel="noopener noreferrer" class="connector-link">
          Open connector YAML in GitLab ↗
        </a>
        <div class="connector-snippet">
          <code class="connector-snippet-code">{{ connectorSnippet }}</code>
          <button type="button"
                  class="connector-copy-btn"
                  [attr.aria-label]="'Copy snippet to clipboard'"
                  (click)="copyConnectorSnippet()">
            <img src="../../assets/content_copy_24dp_026CDF_FILL0_wght400_GRAD0_opsz24.png" alt="Copy" />
          </button>
          <span class="connector-copied" *ngIf="connectorSnippetCopied">Copied!</span>
        </div>
      </div>

      <div class="add-venue-actions">
        <tm1-button variant="outline" [disabled]="saving" (click)="backToForm()">Back</tm1-button>
        <tm1-button variant="solid" [disabled]="saving" (click)="confirmSave()">
          {{ saving ? 'Saving…' : 'Confirm & save' }}
        </tm1-button>
      </div>
    </div>
  </ng-container>
  </div>
</div>
